import { Flex, FlexProps, Spacer, useBreakpointValue } from "@chakra-ui/react";
import { ReactNode } from "react";

import { colors } from "src/colors";

type Props = FlexProps & {
  mobileProps?: FlexProps;
  bothViewport?: boolean;
};

const stickyProps: FlexProps = {
  w: "100%",
  p: 4,
  pb: 8,
  position: "fixed",
  left: 0,
  bottom: 0,
  bg: colors.white.off,
  boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.05)",
  justify: "center",
  align: "center",
  gap: 4,
  zIndex: 1
};

export const FixedButtonsWrapper = ({
  children,
  mobileProps,
  bothViewport = false,
  ...props
}: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (bothViewport) {
    return (
      <MobileWrapper>
        <Flex {...stickyProps} {...mobileProps} {...props}>
          {children}
        </Flex>
      </MobileWrapper>
    );
  }

  return (
    <>
      {isMobile ? (
        <MobileWrapper>
          <Flex {...stickyProps} {...mobileProps}>
            {children}
          </Flex>
        </MobileWrapper>
      ) : (
        <Flex justify="center" align="center" gap={4} {...props}>
          {children}
        </Flex>
      )}
    </>
  );
};

export default FixedButtonsWrapper;

type MobileWrapperProps = {
  children: ReactNode;
};

const MobileWrapper = ({ children }: MobileWrapperProps) => {
  return (
    <>
      <Spacer mt={12} />

      {children}
    </>
  );
};
